import React from 'react';

var Required = function Required() {
  return /*#__PURE__*/React.createElement("span", {
    className: "text-danger pl-1",
    style: {
      position: 'absolute'
    }
  }, "*");
};

Required.displayName = "Required";
export default Required;
//# sourceMappingURL=Required.js.map